import React from 'react';

import Checkbox from '@mui/material/Checkbox';
import Tooltip from '@mui/material/Tooltip';

import {trainingAndFieldRoleEnum, contentCreatingRoleEnum, administrationRoleEnum} from '../../../../serverClientShared/sharedEnums';
import DynamicAvatar from '../../../Shared/DynamicAvatar';

const camelToSentence = (str = '') => {
    const spaced = str.replace(/([A-Z])/g, ' $1').trim();
    return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1).toLowerCase() : '';
};

const formatRole = (role) => role === trainingAndFieldRoleEnum.OPERATOR_3D ? 'Operator MR' : camelToSentence(role);

const getMemberRoleInfo = (user) => {
    if (user.IsWorkspaceOwner) return {label: 'Owner', tooltip: null};

    const admin = user.AdministrationRole || administrationRoleEnum.NONE;
    if (admin === administrationRoleEnum.WORKSPACE_ADMIN) return {label: 'Admin', tooltip: null};

    if (user.RolePresetName) return {label: user.RolePresetName, tooltip: null};

    const roles = [];
    const training = user.TrainingAndFieldRole || trainingAndFieldRoleEnum.NONE;
    const content = user.ContentCreationRole || contentCreatingRoleEnum.NONE;
    if (admin !== administrationRoleEnum.NONE) roles.push(camelToSentence(admin));
    if (content !== contentCreatingRoleEnum.NONE) roles.push(camelToSentence(content));
    if (training !== trainingAndFieldRoleEnum.NONE) roles.push(formatRole(training));
    if (roles.length === 0) return null;
    if (roles.length === 1) return {label: roles[0], tooltip: null};
    return {label: `${roles.length} roles`, tooltip: roles.join(', ')};
};

const ROLE_BADGE_STYLE = {
    color: 'var(--classicbutton-normal-color)',
    backgroundColor: 'color-mix(in srgb, var(--classicbutton-normal-color) 10%, transparent)',
};

const TOOLTIP_PROPS = {
    tooltip: {
        className: '!text-base !text-main-normal !bg-background-normal !border !border-panels-normal !shadow-lg !rounded-input',
    },
};

const RoleBadge = ({label, tooltip}) => {
    const badge = (
        <span className="text-xs font-medium flex-shrink-0 px-2 py-0.5 rounded-menu cursor-default" style={ROLE_BADGE_STYLE}>
            {label}
        </span>
    );
    if (!tooltip) return badge;
    return (
        <Tooltip title={tooltip} placement="top" enterDelay={300} componentsProps={TOOLTIP_PROPS}>
            {badge}
        </Tooltip>
    );
};

export const MemberRow = ({user, checked, onToggle}) => {
    const fullName = [user.FirstName, user.LastName].filter(Boolean).join(' ');
    const avatarUser = {Name: user.FirstName, LastName: user.LastName};
    const roleInfo = getMemberRoleInfo(user);

    return (
        <div
            data-testid={`select-member-${user.Email || ''}`}
            className="flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer hover:bg-windowsandmenus-hover"
            onClick={onToggle}
        >
            <Checkbox size="small" checked={checked} onChange={() => {}} style={{padding: 2}} />
            <DynamicAvatar
                user={avatarUser}
                imageSrc={user.UserIcon}
                style={{width: 32, height: 32, fontSize: 12}}
            />
            <div className="flex-1 min-w-0">
                <div className="text-sm text-main-normal truncate">{fullName || user.Email}</div>
                {fullName && <div className="text-2xs text-main-light truncate">{user.Email}</div>}
            </div>
            {user.IsInvite
                ? <span className="text-xs font-medium flex-shrink-0 px-2 py-0.5 rounded-menu cursor-default text-main-normal bg-panels-normal">Invited</span>
                : roleInfo && <RoleBadge label={roleInfo.label} tooltip={roleInfo.tooltip} />
            }
        </div>
    );
};
